const ShowHoversOnMouseDevices = () => {

    interface MousePosition { X: number, Y: number };

    var userIsTouching = false;
    var currentPosition: MousePosition | undefined; //undefined initially and when touched until first mouse move.

    document.addEventListener('touchstart', e => {
        document.documentElement!.classList.remove("show-hovers");
        userIsTouching = true;
        currentPosition = undefined;
    });
    document.addEventListener('touchend', e => {
        userIsTouching = false;
    });

    document.addEventListener('mousemove', e => {
        if (!userIsTouching) {
            let newPosition = { X: e.screenX, Y: e.screenY };
            if (currentPosition && (currentPosition.X !== newPosition.X || currentPosition.Y !== newPosition.Y)) {
                document.documentElement!.classList.add("show-hovers");
            }
            currentPosition = newPosition;
        }
    });
}

export { ShowHoversOnMouseDevices }
